export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-ui": { "email": { "notSentTitle": "Email not sent", "notSentMessage": "Sorry, there was a problem sending this email. Please try again later." } } } });
};